module.exports = __webpack_public_path__ + "static/media/inplayer-logo-white.fe612768.svg";